import {
  ADD_CURRENT_QUESTION,
  ADD_QUESTIONS_LIST,
  ADD_QUESTION_MODULE,
  SET_CURRENT_QUESTION,
  SET_TIME,
  TIME_OUT,
  NEXT_QUESTION,
  RESET_SUBTEST,
  SET_GLOBAL_COUNT,
} from './reducesTypes'

export const initialQuestion = {
  timer: '',
  moduleType: '',
  time_out: '',
  moduleName: '',
  current: 1,
  currentGlobal: 1,
  offset: 0,
  questionsList: [],
}

export function questionReducer(state, action) {
  switch (action.type) {
    case SET_TIME:
      return {
        ...state,
        timer: action.time,
      }

    // case ADD_QUESTION_MODULE:
    //   return {
    //     ...state,
    //     ...action.payload,
    //   }
    case ADD_QUESTION_MODULE:
      return {
        ...state,
        ...action.payload,
        current: 1,
        currentGlobal: action.payload.offset + 1,
        offset: action.payload.offset,
      }
    case TIME_OUT:
      return {
        ...state,
        timeOut: action.timeOut,
      }
    case SET_CURRENT_QUESTION:
      return {
        ...state,
        current: action.currentPage,
      }
    case ADD_CURRENT_QUESTION:
      const newCurrentQuestion = state.current + 1
      return {
        ...state,
        current: newCurrentQuestion,
      }
    case ADD_QUESTIONS_LIST:
      return {
        ...state,
        questionsList: action.list,
      }

    case NEXT_QUESTION:
      return {
        ...state,
        current: state.current + 1,
        currentGlobal: state.currentGlobal + 1,
      }

    case RESET_SUBTEST:
      return {
        ...state,
        current: 1,
      }

    case SET_GLOBAL_COUNT:
      return {
        ...state,
        currentGlobal: action.payload,
      }

    default:
      throw Error('No type match!')
  }
}
